import React from "react";
import { useSelector } from "react-redux";

const PublishSaleModal = ({ isOpen, onClose, onConfirm, saleData, loading = false }) => {
  const { isPartsURL, isAccessoriesURL } = useSelector((state) => state.domain);
  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-content">
          <h3 className="publish-modal-title">Publish Sale</h3>
          <p className="publish-modal-message">
            Are you sure you want to publish this sale? This action cannot be
            undone.
          </p>

          <div className={`${isPartsURL ? "sale-summary-parts" : isAccessoriesURL ? "sale-summary-acc" : "sale-summary"}`}>
            <div className="summary-row">
              <span className="summary-row-label">Total Amount</span>
              <span className="summary-row-value">
                €{saleData?.totalAmount?.toFixed(2) || "0.00"}
              </span>
            </div>

            <div className="summary-row">
              <span className="summary-row-label">Paid Amount</span>
              <span className="summary-row-value">
                €{saleData?.paidAmount?.toFixed(2) || "0.00"}
              </span>
            </div>
            
            <div className={`${isPartsURL ? "summary-row-parts" : isAccessoriesURL ? "summary-row-acc" : "summary-row"}`}>
              <span className="resulting-balance-summary-row-label">Resulting Balance</span>
              <span className="resulting-balance-summary-row-value">
                €{saleData?.resultingBalance?.toFixed(2) || "0.00"}
              </span>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button 
            className={`${isPartsURL ? "btn-primary-parts" : isAccessoriesURL ? "btn-primary-acc" : "btn-primary"}`} 
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? 'Publishing...' : 'Confirm Publish'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PublishSaleModal;
